import {Component, Input, OnInit, OnDestroy} from '@angular/core';
import { UiService } from '../../services/ui.service';
import {Observable, Subject, timer} from "rxjs";
import {takeUntil} from "rxjs/operators";
import { CommonModule } from '@angular/common';

@Component({
    selector: 'takeover-loader',
    templateUrl: './takeover-loader.component.html',
    styleUrls: ['./takeover-loader.component.sass'],
    imports: [CommonModule],
    standalone: true,
})
export class TakeoverLoaderComponent implements OnInit, OnDestroy {

    @Input('type') type;
    @Input('title') title;
    multiplier = 1.5;
    first_statement = 'Configuring';
    iterator:Observable<number> = timer(0, 1000 * this.multiplier)
    idx = -1;
    $destroy:Subject<void> = new Subject<void>();

    bank = [
         "Sending hamsters to wheels"
        ,"Speeding up to 88mph"
        ,"Making mixtape"
        ,"Gathering wood"
        ,"Are we there yet?"
        ,"Charging batteries"
        ,"Threading the needle"
        ,"Planting a windfarm"
        ,"Setting the kindling"
        ,"Talking to the ether"
        ,"Making the thing talk to the other thing"
        ,"Dialling up"
        ,"Making the wheels spin"
        ,"Gettin those doggies movin"
        ,"Putting the wagons in a circle"
        ,"Flexing our muscles"
        ,"Check, check, one, two"
        ,"Adjusting foldback levels"
        ,"Turning on the lights"
        ,"Taking measurements"
        ,"Making it funky"
        ,"Almost there"
        ,"Is that the time?"
        ,"I'll be home for Christmas"
        ,"Periscope up"
        ,"Letting the dough rise"
        ,"Gatheries daisies"
        ,"Gathering sunshine"
        ,"Installing solar panels"
        ,"Tamping the coffee"
        ,"Engage warp"
        ,"Now, where did I put this thing?"
        ,"Has anyone seen my glasses"
        ,"Making coffee"
        ,"Making tea"
        ,"Is this thing on?"
        ,"Dive, dive!"
        ,"Battoning down the hatches"
        ,"Harvesting lettuce"
        ,"Fastening seatbelts"
        ,"Unboxing now"
        ,"Let's make history"
        ,"Synergising mission-critical infrastructure"
        ,"Incentivising global partnerships"
        ,"Doing the Macarena"
        ,"How we doing so far?"
        ,"Taking coffee orders"
        ,"Searching the heavens"
        ,"Setting the sails"
        ,"Last drinks"
        ,"That's no moon"
        ,"Swinging the tiller"
        ,"Shucking oysters"
        ,"Booting up"
        ,"Never has waiting been more fun, yes?"
        ,"We have nothing to fear except the end of the internet"
        ,"This is some of our best work"
        ,"We wrote these wait messages individually"
        ,"Drop and give me 20"
        ,"We lift pixels"
        ,"Designed with loving care"
        ,"Zooming in"
        ,"Fastening seatbelts"
        ,"It's 25 to midnight and fifteen miles of track"
        ,"Is it just me or is this fun?"
        ,"This is the most fun I've had today"
        ,"Make it so"
        ,"Carpe diem"
        ,"Can you hear me down the back?"
        ,"If at first you don't succeed, wait a tad longer"
        ,"We're nearly there"
        ,"I see daylight"
        ,"Are those Klingons?"
        ,"We're giving it all she's got"
        ,"Two to beam up"
        ,"We're close"
        ,"So close right now"
        ,"This is fun, isn't it?"
        ,"I once caught a fish THIS BIG"
        ,"Come here often?"
        ,"Home is where the heart is"
        ,"Remember IE3? Us neither."
        ,"It was the best of times. It was the worst of times."
        ,"When I grow up I will be a website"
        ,"You can't even remember web 1.0, amiright?"
        ,"Can I eat this pizza?"
        ,"Who let the dogs out?"
        ,"Has anyone seen my cap?"
        ,"Boiling the kettle"
        ,"Get excited"
        ,"Talk to me"
        ,"Backend, meet Frontend"
        ,"Don't mix your drinks, now"
        ,"We are, like, SO close"
        ,"Wait for it"
        ,"Applying lip gloss"
        ,"Just feeding the Unicorns"
    ]
    constructor(public ui: UiService) {
    }
    ngOnInit(){
        if(!this.title) {
            switch (this.type){
                case 'account':
                    this.title = 'Setting up your account...';
                    this.first_statement = 'Configuring your account'
                    break;
                case 'event':
                    this.title = 'Setting up your new event...';
                    this.first_statement = 'Configuring your event'
                    break;
                default:
                    this.title = 'Loading...';
            }
        }
        this.bank = this.shuffle(this.bank);
        this.bank.unshift(this.first_statement)
        this.setupAnimation();
    }

    setupAnimation(){
        this.iterator.pipe(takeUntil(this.$destroy)).subscribe(number=>{
            this.idx = number;
            if(number === this.bank.length + 1){
                this.$destroy.next();
                this.setupAnimation();
            }
        })
    }

    trackByFn(index, item) {
        return index; // or item.id
    }

    shuffle(array) {
        let currentIndex = array.length, temporaryValue, randomIndex;

        // While there remain elements to shuffle...
        while (0 !== currentIndex) {

            // Pick a remaining element...
            randomIndex = Math.floor(Math.random() * currentIndex);
            currentIndex -= 1;

            // And swap it with the current element.
            temporaryValue = array[currentIndex];
            array[currentIndex] = array[randomIndex];
            array[randomIndex] = temporaryValue;
        }

        return array;
    }


    ngOnDestroy(){
        this.$destroy.next(); this.$destroy.complete();
    }
}
